import { esc } from '../ui/modal';
import { amountGroupsRowHtml, readAmountBounds, readDepositBalance, wireAmountGroups } from './clicker-amount-fields';
import { t } from '../ui/lang';
export async function fetchClickerServers() {
    try {
        const res = await fetch('/api/clicker/servers');
        if (res.ok)
            return await res.json();
    }
    catch { /* show empty */ }
    return [];
}
/** Report languages the clicker ships catalogs for (mirrors server/teams.ts NOTIFY_LANGS). */
const TG_LANGS = [
    { value: 'en', label: t('clicker.lang_en') },
    { value: 'ru', label: t('clicker.lang_ru') },
];
/** Admin-only per-farm clicker configuration form (server + parameters). */
export async function renderFarmClickerConfig(panel, farmId) {
    panel.innerHTML = `<div class="access-loading">${t('common.loading')}</div>`;
    let servers = [];
    let config = {
        server_id: null, bucket_code: '', operators_group: '', tg_chats: '', loop_pause_sec: 20,
        max_initial_amount: null, min_initial_amount: 0,
        deposit_min_balance: null, deposit_max_balance: null,
        tg_proxy_url: '', tg_lang: 'en', team_id: null, team_name: '',
    };
    try {
        servers = await fetchClickerServers();
        const r = await fetch(`/api/farms/${farmId}/clicker`);
        if (r.ok)
            config = await r.json();
    }
    catch { /* fall back to empty config */ }
    // The two fields below live on the farm's TEAM, not on this farm — the badge says so
    // on the label instead of repeating a full sentence under each one. An ungrouped farm
    // has no team to name, and both fields are disabled there anyway, so it gets no badge.
    const teamBadge = config.team_id === null ? '' : `<span class="field-badge" title="${esc(t('clicker.team_wide_title', { team: config.team_name }))}">${t('clicker.team_wide')}</span>`;
    const options = [
        `<option value="">${t('common.none')}</option>`,
        ...servers.map((s) => `<option value="${s.id}" ${config.server_id === s.id ? 'selected' : ''}>${esc(s.name)}</option>`),
    ].join('');
    panel.innerHTML = `
        <div class="settings-section">
            <h3 class="settings-section__title">${t('clicker.config_title')}</h3>
            <form class="settings-clicker-form clicker-config-form" novalidate>
                <section class="clicker-config-group">
                    <h4 class="clicker-config-group__title">${t('clicker.group_processing')}</h4>
                    <div class="clicker-config-grid">
                        <div class="modal__field">
                            <label>${t('clicker.server_label')}</label>
                            <select class="settings-input fc-server">${options}</select>
                            ${servers.length === 0 ? `<p class="settings-hint">${t('clicker.no_servers_hint')}</p>` : ''}
                        </div>
                        <div class="modal__field">
                            <label>${t('clicker.bucket_code')}</label>
                            <input class="settings-input fc-bucket-code" type="text" autocomplete="off" value="${esc(config.bucket_code)}" />
                        </div>
                        <div class="modal__field">
                            <label>${t('clicker.operators_group')}</label>
                            <input class="settings-input fc-operators-group" type="text" autocomplete="off" placeholder="${t('clicker.operators_group_placeholder')}" value="${esc(config.operators_group)}" />
                        </div>
                        <div class="modal__field">
                            <label>${t('clicker.loop_pause')}</label>
                            <input class="settings-input fc-pause" type="number" min="0" step="1" value="${config.loop_pause_sec}" />
                        </div>
                        <div class="modal__field">
                            <label>${t('clicker.notify_lang')}${teamBadge}</label>
                            <select class="settings-input fc-tg-lang"${config.team_id === null ? ' disabled' : ''}>
                                ${TG_LANGS.map((l) => `<option value="${l.value}"${config.tg_lang === l.value ? ' selected' : ''}>${esc(l.label)}</option>`).join('')}
                            </select>
                            <p class="settings-hint">${config.team_id === null ? t('clicker.notify_lang_no_team') : t('clicker.notify_lang_hint')}</p>
                        </div>
                    </div>
                </section>
                <section class="clicker-config-group">
                    <h4 class="clicker-config-group__title">${t('clicker.group_telegram')}</h4>
                    <div class="clicker-config-grid">
                        <div class="modal__field">
                            <label>${t('clicker.tg_chats')}</label>
                            <input class="settings-input fc-tg" type="text" autocomplete="off" placeholder="${t('clicker.tg_chats_placeholder')}" value="${esc(config.tg_chats)}" />
                        </div>
                        <div class="modal__field clicker-config-grid__wide">
                            <label>${t('clicker.tg_proxy')}${teamBadge}</label>
                            <div class="field-with-action">
                                <input class="settings-input fc-tg-proxy" type="text" autocomplete="off"
                                       placeholder="socks5://user:pass@203.0.113.10:1080"
                                       value="${esc(config.tg_proxy_url)}"${config.team_id === null ? ' disabled' : ''} />
                                <button type="button" class="field-test-btn fc-tg-proxy-test"${config.team_id === null ? ' disabled' : ''}>${t('clicker.tg_proxy_test')}</button>
                            </div>
                            <p class="settings-hint fc-tg-proxy-result" style="display:none"></p>
                            <p class="settings-hint">${config.team_id === null
        ? t('clicker.tg_proxy_no_team')
        : t('clicker.tg_proxy_hint')}</p>
                            ${config.team_id === null ? '' : `
                                <details class="clicker-config-help">
                                    <summary class="clicker-config-help__title">${t('clicker.tg_proxy_format_title')}</summary>
                                    <p class="settings-hint">${t('clicker.tg_proxy_format_hint')}</p>
                                </details>`}
                        </div>
                    </div>
                </section>
                <section class="clicker-config-group">
                    <h4 class="clicker-config-group__title">${t('clicker.group_limits')}</h4>
                    ${amountGroupsRowHtml({
        min: config.min_initial_amount ?? 0,
        max: config.max_initial_amount,
        minPlaceholder: '0',
        maxPlaceholder: '9000000',
    }, {
        min: config.deposit_min_balance,
        max: config.deposit_max_balance,
        minPlaceholder: '0',
        maxPlaceholder: '20000000',
    })}
                </section>
                <button type="submit" class="modal__submit clicker-config-form__submit">${t('common.save')}</button>
            </form>
            <div class="settings-error modal__error fc-error" style="display:none"></div>
        </div>
    `;
    wireAmountGroups(panel);
    const form = panel.querySelector('.settings-clicker-form');
    const serverSel = panel.querySelector('.fc-server');
    const bucketCodeInput = panel.querySelector('.fc-bucket-code');
    const operatorsGroupInput = panel.querySelector('.fc-operators-group');
    const tgInput = panel.querySelector('.fc-tg');
    const tgProxyInput = panel.querySelector('.fc-tg-proxy');
    const tgLangSel = panel.querySelector('.fc-tg-lang');
    const pauseInput = panel.querySelector('.fc-pause');
    const errorEl = panel.querySelector('.fc-error');
    wireTgProxyTest(panel, farmId, tgProxyInput);
    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        errorEl.style.display = 'none';
        const pause = parseInt(pauseInput.value, 10);
        if (pauseInput.value !== '' && (!Number.isFinite(pause) || pause < 0)) {
            errorEl.textContent = t('clicker.pause_invalid');
            errorEl.style.display = 'block';
            return;
        }
        const bounds = readAmountBounds(panel);
        if ('error' in bounds) {
            errorEl.textContent = bounds.error;
            errorEl.style.display = 'block';
            return;
        }
        const balance = readDepositBalance(panel);
        if ('error' in balance) {
            errorEl.textContent = balance.error;
            errorEl.style.display = 'block';
            return;
        }
        const btn = form.querySelector('.modal__submit');
        btn.disabled = true;
        try {
            const r = await fetch(`/api/farms/${farmId}/clicker`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    server_id: serverSel.value ? parseInt(serverSel.value, 10) : null,
                    bucket_code: bucketCodeInput.value.trim(),
                    operators_group: operatorsGroupInput.value.trim(),
                    tg_chats: tgInput.value.trim(),
                    // Team-wide field — the server writes it to the farm's team, not to
                    // farm_clicker_config. Omitted for an ungrouped farm (no team to
                    // write to), where the input is disabled anyway.
                    ...(config.team_id === null ? {} : {
                        tg_proxy_url: tgProxyInput.value.trim(),
                        tg_lang: tgLangSel.value || config.tg_lang,
                    }),
                    loop_pause_sec: pauseInput.value === '' ? 20 : pause,
                    max_initial_amount: bounds.max,
                    // Farm-level floor is always stored; an empty field means "no minimum".
                    min_initial_amount: bounds.min ?? 0,
                    deposit_min_balance: balance.min,
                    deposit_max_balance: balance.max,
                }),
            });
            if (!r.ok) {
                errorEl.textContent = (await r.json()).error ?? t('common.failed_to_save');
                errorEl.style.display = 'block';
                return;
            }
            const original = btn.textContent;
            btn.textContent = t('common.saved');
            setTimeout(() => { btn.textContent = original; }, 1500);
        }
        catch {
            errorEl.textContent = t('clicker.network_error');
            errorEl.style.display = 'block';
        }
        finally {
            btn.disabled = false;
        }
    });
}
/**
 * The Test button next to the Telegram proxy: the panel dials api.telegram.org through the
 * URL that is IN THE FIELD (not the saved one — test first, save what worked) and says what
 * came back. A proxy that does not answer is a normal answer here, not a failed request,
 * so the verdict is a coloured line under the field rather than the form's error box.
 */
function wireTgProxyTest(panel, farmId, input) {
    const btn = panel.querySelector('.fc-tg-proxy-test');
    const out = panel.querySelector('.fc-tg-proxy-result');
    if (!btn || !out)
        return;
    const say = (text, kind) => {
        out.className = `settings-hint fc-tg-proxy-result settings-hint--${kind}`;
        out.textContent = text;
        out.style.display = 'block';
    };
    btn.addEventListener('click', async () => {
        const label = btn.textContent;
        btn.disabled = true;
        btn.textContent = t('clicker.tg_proxy_testing');
        try {
            const r = await fetch(`/api/farms/${farmId}/clicker/tg-proxy-test`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ tg_proxy_url: input.value.trim() }),
            });
            const data = await r.json();
            if (!r.ok) {
                say(data.error ?? t('clicker.network_error'), 'err');
                return;
            }
            const took = { ms: String(data.ms ?? 0) };
            if (!data.ok)
                say(t('clicker.tg_proxy_failed', { error: data.error ?? '' }), 'err');
            else if (data.warning)
                say(t('clicker.tg_proxy_reached', { ...took, note: data.warning }), 'warn');
            else
                say(t('clicker.tg_proxy_ok', { ...took, bot: data.bot ?? '' }), 'ok');
        }
        catch {
            say(t('clicker.network_error'), 'err');
        }
        finally {
            btn.disabled = false;
            btn.textContent = label;
        }
    });
}
